export default ($options) => Object.assign({
  events: false,
  eventListeners: false,
  enableEvents: true,
  enableQuerySelectors: true,
}, $options)
